import { Injectable } from "@angular/core";
import { TaxiParada } from "@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity";
import { TaxiParadaControllerInteface } from "app/interface/mob/taxi-parada-controller.inteface";
import { TaxiParadaListDTO } from "app/model/dtos/mob/taxi-parada.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";


@Injectable()
export class TaxiParadaController implements TaxiParadaControllerInteface<TaxiParada>{
    constructor() { }

    find(filters ? : IFilter): Promise <TaxiParada[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiparada',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array<TaxiParada> ())
        );

        return request.call();
    }

    get(id: number, id_2: number): Promise <TaxiParada> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiparada/:cdPonto/:cdParada',
                    environment: environment,
                    pathParams: new JSONData({
                        cdPonto: id,
                        cdParada: id_2
                    }),
                }),
            }),
            new HttpResponse(new TaxiParada())
    );

        return request.call();
    }

    create(entity: TaxiParada): Promise <TaxiParada> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/taxiparada',
                    environment: environment
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TaxiParada()
            )
        );

        return request.call();
    }

    update(entity: TaxiParada): Promise <TaxiParada> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/taxiparada/:cdPonto/:cdParada',
                    environment: environment,
                    pathParams: new JSONData({
                        cdPonto: entity.cdPonto,
                        cdParada: entity.cdParada
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TaxiParada()
            )
        );
        return request.call();
    }
    
    pagedFind(filters ? : IFilter): Promise<TaxiParadaListDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiparada/paradas',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new TaxiParadaListDTO)
        );

        return request.call();
    }

    findParadas(filters ? : IFilter): Promise<TaxiParadaListDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/taxiparada/paradas-list',
                    environment: environment,
                    filter: filters,
                }),
            }),
            new HttpResponse(new TaxiParadaListDTO)
        );

        return request.call();
    }

}